export default __webpack_public_path__ + "assets/img_olivia_talks-b75a886b.png";